/* eslint-disable class-methods-use-this */
/* eslint-env browser */
/* eslint no-underscore-dangle: 0 */
/* eslint-disable camelcase */
// eslint-disable-next-line import/extensions
import 'core-js/stable'
import 'regenerator-runtime'
import cookie from 'js-cookie'
import { InfaceEnv } from '@inface-sdk/common'
import { InfaceAuth, InfaceAuthError } from '@inface-sdk/web-auth'
import locale2 from 'locale2'
import UAParser from 'ua-parser-js'
import Sentry from './config/sentry'
import { DISABLED_WEB_LAUNCH_CLIENT_IDS } from './constants/EXCEPT_ACTIONS'
import { ENV_VARIABLE, GW_PATH } from './constants'
import { COOKIE, PATH } from './constants/GLOBAL_VARIABLE'
import { LocalKRPC, LocalARENA, LocalJPPC } from './local'
import { SSO } from './features/sso'
import { SSOForWebGame } from './features/sso-for-web-game'
import { IacOAuth, IacTerms } from './features/iac'
import { PlayNow } from './features/playNow'
import { IIV } from './features/iiv'
import {
  ConsoleLinking, TwitchLinking, ChzzkLinking, DiscotechLinking, PlatformSignin, LoginSelector,
} from './features/ial'
import { AccountSetting } from './features/sa'
import { GameAuthService, WebAuthService } from './services'
import 'urlpattern-polyfill'

import './config/debugger'
// import './mocks/worker.js'
import './plugins'

import packageJson from '../package.json'
import { showInsignLog } from './utils/log'
import { URI, LNA } from './utils/common'
import { NxPlug } from './features/nxplug'
import { STATUS } from './features/iac/enum'
// main()

const LOCATION = window.location

// for IE to use location.origin
if (!window.location.origin) {
  window.location.origin = `${LOCATION.protocol}//${LOCATION.hostname}${LOCATION.port ? `:${LOCATION.port}` : ''}`
}

const HOSTNAME = LOCATION.hostname
const PATHNAME = LOCATION.pathname
const SEARCH_PARAMS = new URLSearchParams(LOCATION.search)

function getParameterByName(name, searchParams = SEARCH_PARAMS) {
  return searchParams.get(name)
}

function getEnv() {
  const pre = HOSTNAME.split('-')

  if (pre.length > 1) {
    return HOSTNAME.split('-')[0]
  }
  return 'live'
}

const LOCALE_PARAM = getParameterByName('locale')?.replace('_', '-')

const ENV = getEnv().substring(0, 2)
const ENV_VALUE = ENV_VARIABLE[ENV]

// SSO 처리가 되는 특수 경로

// 다국어 처리
const LOCALE = locale2 || 'en-US'
const LANGUAGE = (LOCALE_PARAM?.split('_')[0] || LOCALE_PARAM?.split('-')[0] || LOCALE.split('-')[0] || 'en').toLowerCase()

// const LOADING_TIMEOUT = 5000 // 5초

class INSIGN {
  constructor() {
    this.infaceAuth = null
    this.localPlatform = null
    this.queryParam = this._queryParam
    this.loadingFlag = false
    this.corsList = []
    this.gameAuthService = null
    this.webAuthService = null
    this.$t = window.$i18next.t
  }

  // eslint-disable-next-line class-methods-use-this
  get _queryParam() {
    try {
      const keys = [
        'redirect_uri',
        'gid',
        'locale',
        'platform',
        'referrer',
        'krpc_member_access_code',
        'jppc_gm',
        'use_game_token',

        // for PC/Mobile type
        'type',
        'port',
        'hsid',
        'country',
        'sso_credential_code',

        // for consoleLink
        'console_type',
        'console_token',
        'ial',
        'link_ticket',
        'redirect_url',
      ]

      const insignCookieStr = cookie?.get(COOKIE.INSIGN)
      const insignCookie = (insignCookieStr && JSON.parse(insignCookieStr)) || {}

      const param = {}
      keys.forEach((key) => {
        param[key] = getParameterByName(key) || insignCookie?.[key]
      })

      return param
    } catch (e) {
      console.error(e)
      return {}
    }
  }

  clearCookieByQuerystring() {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(COOKIE)) {
      const param = getParameterByName(`clear${value}`) // ex) clear_ifplatform
      if (param && param === 'true') {
        const NEXON_DOMAIN = 'nexon.com'
        cookie?.remove(COOKIE[key], { domain: NEXON_DOMAIN })
        this.clearInsignCookie()
      }
    }
  }

  shouldBypassGateway() {
    // Safari BFCache 복원 여부 판단 (모든 브라우저 지원)
    const navEntries = performance.getEntriesByType('navigation')
    const isBFCacheRestored = navEntries.length > 0 && navEntries[0].type === 'back_forward'

    return isBFCacheRestored
  }

  handleGatewayWithSafariSupport() {
    if (this.shouldBypassGateway()) {
      console.warn('[bypass gateway]')
      window.history?.back()
      return
    }

    // Safari BFCache 대응
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) { // 오직 BFCache로 복원될 때만 발생
        window.history?.back()
      }
    })
  }

  async init() {
    try {
      this.handleGatewayWithSafariSupport()
      this.clearCookieByQuerystring()

      const {
        type,
        country,
        locale,
        krpc_member_access_code,
        jppc_gm,
        use_game_token: useGameTokenParam,
      } = this.queryParam

      const gid = getParameterByName('gid') || cookie?.get(COOKIE.GID)
      const platformByCountry = type === 'ingame-mobile' ? this.getPlatformByCountry(country) : undefined
      const platform = getParameterByName('platform') || cookie?.get(COOKIE.PLATFORM) || platformByCountry
      const krpc = {
        memberAccessCode: krpc_member_access_code,
      }
      const jppc = {
        gm: jppc_gm,
      }

      const useLoading = getParameterByName('use_loading') !== 'false'
      if (useLoading) {
        window.$showPageLoading()
      }

      this.useGameToken = useGameTokenParam !== 'false'

      this.infaceAuth = new InfaceAuth({
        env: ENV, gid, platform, locale, __useNppMonitor: false,
      })

      this.webAuthService = new WebAuthService({
        gid, env: ENV, platform, locale, __useNppMonitor: false,
      })
      this.gameAuthService = new GameAuthService({
        gid, env: ENV, locale, country,
      })

      this.corsList = await this.getCorsList()

      if (gid) {
        const gidSettingResult = await this.infaceAuth.getGidSetting({ gid })
        this.webAuthService.addBreadcrumbByInfaceAuthMethod('getGidSetting', gidSettingResult)
        this.infaceAuth.gidSetting = gidSettingResult

        // 콘솔에서 가져온 krpc_member_access_code 추가
        if (this.infaceAuth.gidSetting.krpcMemberAccessCode) {
          krpc.memberAccessCode = krpc_member_access_code || this.infaceAuth.gidSetting.krpcMemberAccessCode
        }
        // 콘솔에서 가져온 jppc_gm 추가
        if (this.infaceAuth.gidSetting.jppcGm) {
          jppc.gm = jppc_gm || this.infaceAuth.gidSetting.jppcGm
        }
      }

      // for debug
      // window._infaceAuth = this.infaceAuth

      // 로컬 플랫폼 조회
      this.localPlatform = await this.getLocalPlatform({ krpc, jppc })

      Sentry.addBreadcrumb({
        type: 'navigation',
        category: 'navigation',
        message: `[move to] ${PATHNAME}`,
        data: {
          from: document.referrer,
          to: `${window.location.origin}${PATHNAME}`,
        },
      })

      switch (PATHNAME) {
        case GW_PATH.ROOT:
          await this.gotoSignin()
          break
        case GW_PATH.SIGNIN:
          await this.processSignin()
          break
        case GW_PATH.PLATFORM_SIGNIN:
        case GW_PATH.AUTH_SELECTOR:
          this.gotoPlatformSignin()
          break
        case GW_PATH.SSO: // sso 토큰 로밍
        case GW_PATH.SSO_BY_TICKET: // sso 토큰 로밍 by ticket
          this.infaceAuth.clearInsignSession()
          this.infaceAuth.guest.clearSession()
          await this.ssoTokenRoaming({ byTicket: PATHNAME === GW_PATH.SSO_BY_TICKET })
          break
        case GW_PATH.SSO_BY_TICKET_FOR_WEB_GAME:
          await this.ssoTokenRoamingForWebGame()
          break
        case GW_PATH.SSO_KRPC:
        case GW_PATH.SSO_JPPC:
          const ifinsign = cookie.get(COOKIE.INSIGN)
          const insignCookie = ifinsign && JSON.parse(ifinsign)

          Sentry.addBreadcrumb({
            type: 'debug',
            category: 'insignCookie',
            data: insignCookie,
            level: 'debug',
          })

          this.infaceAuth.platform.npp = cookie && cookie.get('NPP')
          if (!this.infaceAuth.platform.npp) { this.infaceAuth.clearSession() }
          await this.redirectOfSignin() // 로컬 로그인 페이지의 리다이렉트
          break
        case GW_PATH.SSO_ARENA:
        case GW_PATH.SSO_ARENA_WEST:
        case GW_PATH.SSO_ARENA_TH:
        case GW_PATH.SSO_ARENA_TW:
        case GW_PATH.SSO_ARENA_SEA:
        case GW_PATH.SSO_ARENA_JP:
          await this.redirectOfSignin() // 로컬 로그인 페이지의 리다이렉트
          break
        case GW_PATH.SSO_SIMPLE: // 간편가입의 로컬세션 생성 후 리다이렉트
          await this.successToSignin()
          break
        case GW_PATH.SIGNOUT:
          this.saveReferrer() // referrer 저장
          this.gotoSignout()
          break
        case GW_PATH.SIGNED_OUT: // 로컬 로그아웃 페이지의 리다이렉트
          this.infaceAuth.clearSession() // 로컬 로그아웃 실패 시 방어코드
          this.gotoRedirect()
          break
        case GW_PATH.SIGNUP:
          this.saveReferrer() // referrer 저장
          this.gotoSignup()
          break
        case GW_PATH.SIGNED_UP: // 가입 페이지의 리다이렉트
          if (this.localPlatform.useSimpleSignup) {
            await this.redirectOfSimpleSignup() // 간편가입 완료 시 로컬세션 생성
          } else {
            await this.redirectOfSignin() // 로컬 가입 후 역방향 로그인 처리
          }
          break
        case GW_PATH.ACCOUNT:
          this.gotoAccount()
          break
        case GW_PATH.REDIRECT:
          this.redirectByPath()
          break
        case GW_PATH.LOADING:
          const login = getParameterByName('login')
          if (login) {
            window.$showLoginLoading()
          } else {
            window.$showPageLoading()
          }
          break
        case GW_PATH.LINK:
          await this.gotoIalConsoleLinkingPage()
          break
        case GW_PATH.LINK_TWITCH:
          this.gotoIalTwitchLinkingPage()
          break
        case GW_PATH.LINK_CHZZK:
          this.gotoIalChzzkLinkingPage()
          break
        case GW_PATH.LINK_DISCOTECH:
          this.gotoIalDiscotechLinkingPage()
          break
        case GW_PATH.OAUTH_AUTHORIZE:
          await this.authorizeOAuth()
          break
        case GW_PATH.LOGIN:
          await this.gotoLogin()
          break
        case GW_PATH.LOGOUT:
          await this.processLogout()
          break
        case GW_PATH.LOGIN_SELECTOR:
        case GW_PATH.LOGIN_SELECTOR_HEADLESS:
          this.gotoLoginSelector(PATHNAME)
          break
        case GW_PATH.PLAYNOW_SIGNIN:
        case GW_PATH.PLAYNOW_SIGNOUT:
        case GW_PATH.PLAYNOW_CODE:
        case GW_PATH.PLAYNOW_TERMS:
          await this.gotoPlayNowPage(PATHNAME)
          break
        case GW_PATH.TOY_TERMS:
          this.gotoToyTermsPage()
          break
        case GW_PATH.ACCOUNT_SETTING:
          this.gotoAccountSettingPage()
          break
        case GW_PATH.IIV:
          this.gotoIivPage()
          break
        case GW_PATH.SECURITY_CHECK_TURNSTILE:
          window.$showTurnstile({ message: this.$t('turnstile_modal.message', { ns: 'security-check' }) })
          break
        default:
      }
    } catch (e) {
      console.error(e)
      const err = e instanceof InfaceAuthError ? e : new InfaceAuthError({
        code: 113901, name: 'FAIL_TO_INIT', message: window.$t('FAIL_TO_INIT'), data: e,
      }) // fail to init

      this.callbackError(err)
    }
  }

  async getLocalPlatform({ krpc, jppc } = {}) {
    let localPlatform = null
    const { ial, sso_credential_code } = this.queryParam
    const { krpcSimpleSignup, arenaSimpleSignup } = this.infaceAuth.gidSetting
    const platformResult = await this.infaceAuth.getPlatform('selector-for-signin', { krpc, jppc })
    this.webAuthService.addBreadcrumbByInfaceAuthMethod('getPlatform', platformResult)

    if (platformResult.code > 200) { // 플랫폼 조회 에러 발생
      throw new InfaceAuthError({ code: platformResult.code, response: platformResult.response, data: platformResult.errorData })
    }

    this.setInsignCookie({ platformData: platformResult.data }) // INSIGN 전용 쿠키 저장

    this.infaceAuth.platform = platformResult.platform
    const realPlatform = platformResult.platform.type !== 'sso' ? platformResult.platform : platformResult.platform.ssoPlatform
    if (realPlatform.type === 'krpc') {
      localPlatform = new LocalKRPC({
        ial,
        memberAccessCode: realPlatform.memberAccessCode,
        useSimpleSignup: krpcSimpleSignup,
        mainUrl: ENV_VALUE.KRPC_MAIN_URL,
        loginUrl: ENV_VALUE.KRPC_LOGIN_URL,
        logoutUrl: ENV_VALUE.KRPC_LOGOUT_URL,
        memberUrl: ENV_VALUE.KRPC_MEMBER_URL,
        ssoUrl: ENV_VALUE.KRPC_NEST_URL,
        ssoCode: sso_credential_code,
      })
    } else if (realPlatform.type === 'arena') {
      const region = realPlatform.region?.toUpperCase()
      const urlKey = !ial && region ? `ARENA_${region}_URL` : 'ARENA_URL' // ial 은 one.nexon.com 으로 이동

      localPlatform = new LocalARENA({
        path: realPlatform.region,
        mainUrl: ENV_VALUE[urlKey],
        useSimpleSignup: arenaSimpleSignup,
        ial,
        unified: region ? '' : 'unified', // 지역 상관 없이 로그인
      })
    } else if (realPlatform.type === 'jppc') {
      localPlatform = new LocalJPPC({
        gm: realPlatform.gm,
        mainUrl: ENV_VALUE.JPPC_URL,
      })
    }

    return localPlatform
  }

  async getCorsList() {
    try {
      const response = await fetch(`${ENV_VALUE.INSIGN_GW_URL}/config/cors/whitelist-domains.json`, { mode: 'cors' })
      const corsList = await response.json()

      Sentry.addBreadcrumb({
        type: 'debug',
        category: 'cors/whitelist-domains.json',
        data: {
          cors: corsList,
        },
        level: 'debug',
      })

      return corsList
    } catch (e) {
      console.error('Failed to get CORS list', e)

      Sentry.withScope((scope) => {
        scope.setLevel('error')
        Sentry.captureMessage('Failed to get CORS list')
      })

      return []
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getPlatformByCountry(country) {
    if (!country) {
      return ''
    }

    switch (country.toLowerCase()) {
      case 'kr':
        return 'krpc'
      case 'jp':
        return 'jppc'
      default:
        return 'arena'
    }
  }

  /**
   * 페이지 이동 전 최종 목적지 도메인 저장
   */
  saveReferrer() {
    try {
      const redirectUri = this.getRedirectUri()

      if (!(redirectUri || document.referrer)) return

      Sentry.addBreadcrumb({
        type: 'debug',
        category: 'referrer',
        data: {
          redirectUri,
          referrer: document.referrer,
        },
        level: 'debug',
      })

      const url = new URL(redirectUri || document.referrer)
      const referrer = `${url.protocol}//${url.hostname}`

      this.addInsignCookie('referrer', referrer) // INSIGN 전용 쿠키 저장

      this.queryParam.referrer = referrer
      this.infaceAuth.client.referrerDomain = referrer
      console.warn('[warning] saveReferrer', referrer)
    } catch (e) {
      console.warn('[warning] saveReferrer', e)

      Sentry.withScope((scope) => {
        scope.setLevel('warning')
        Sentry.captureMessage('[warning] saveReferrer')
      })
    }
  }

  // eslint-disable-next-line class-methods-use-this
  addInsignCookie(key, value) {
    if (!cookie) return

    const ifinsign = cookie.get(COOKIE.INSIGN)
    const insignCookie = (ifinsign && JSON.parse(ifinsign)) || {}
    insignCookie[key] = value

    const domain = window.location.host
    cookie.set(COOKIE.INSIGN, JSON.stringify(insignCookie), { domain })
  }

  setInsignCookie({ platformData = {}, ...other }) {
    if (!cookie) return

    const domain = window.location.host
    const { adult_age, country, platform } = platformData

    const insignData = {
      ...this.queryParam,
      ...other,
      adult_age,
      selector: {
        adult_age,
        country,
        platform,
      },
    }

    cookie.set(COOKIE.LANGUAGE, LANGUAGE, { domain })
    cookie.set(COOKIE.INSIGN, JSON.stringify(insignData), { domain })
  }

  // eslint-disable-next-line class-methods-use-this
  clearInsignCookie() {
    if (!cookie) return

    const domain = window.location.host
    cookie.remove(COOKIE.LANGUAGE, { domain })
    cookie.remove(COOKIE.INSIGN, { domain })
  }

  // eslint-disable-next-line class-methods-use-this
  isIE() {
    const ua = window.navigator.userAgent
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
  }

  async callbackError(infaceAuthError = {}) {
    const {
      code, name, message,
    } = infaceAuthError
    const { type = 'web', locale } = this.queryParam
    // console.error('Code: ', code, infaceAuthError)
    // console.error('Data: ', data, data?.error)

    // NOTE. 250523 넥슨플레이 error_message 긴급 대응
    const packageName = getParameterByName('package_name') ?? ''
    if (packageName && PATHNAME === GW_PATH.SSO_BY_TICKET_FOR_WEB_GAME) {
      const errorData = {
        error_code: code,
        error_name: name,
        error_message: message,
      }
      new SSOForWebGame({}).sendSignalToMobile(errorData)
      return
    }

    if (type === 'ingame') {
      this.redirectForGame('fail', { code, message: name })
    } if (type === 'ingame-mobile') {
      this.redirectForMobile('fail', { code, message: name })
    }

    await this.webAuthService.handleError({ infaceAuthError, infaceAuth: this.infaceAuth, type }) // 공통 에러 처리

    if (type === 'web') {
      // window.history.back() // alert 띄운 후 이전페이지로 이동
      const params = new URLSearchParams({ login: 'fail' })
      if (locale) {
        params.append('locale', locale)
      }

      const url = `${ENV_VALUE.INSIGN_GW_URL}/close?${params.toString()}` // alert 띄운 후 에러 페이지로 이동
      URI.navigateToUrlWithoutHistory(url)
    }
  }

  redirectByPath() {
    const { type = 'web' } = this.queryParam
    const response = getParameterByName('response')
    const code = getParameterByName('code')
    const message = getParameterByName('message')
    const isFail = response === 'fail'
    const error = isFail ? {
      code: code || 113909,
      message: message || 'INVALID_ACCESS',
    } : {}

    if (type === 'ingame') {
      this.redirectForGame(response, error)
    } if (type === 'ingame-mobile') {
      this.redirectForMobile(response, error)
    }

    if (isFail) {
      const detailErrorCode = code ? `(${code})` : ''
      const alertMessage = `${window.$t('ERROR_OCCURRED')}\n\n${window.$t('ERROR_CODE')}: ${error.code}${detailErrorCode}`

      console.error(alertMessage)

      Sentry.addBreadcrumb({
        type: 'query',
        category: 'query',
        message: alertMessage,
        data: {
          response,
          code,
          message,
        },
        level: 'info',
      })

      Sentry.withScope((scope) => {
        scope.setLevel('error')
        Sentry.captureMessage('[redirectByPath] response is fail')
      })

      if (type === 'web') {
        alert(alertMessage)
      }
    }

    if (type === 'web') {
      this.clearInsignCookie()
      URI.navigateToUrlWithoutHistory(this.localPlatform?.mainUrl) // 로컬 홈으로 이동
    }
  }

  getRedirectUri(uri = this.queryParam.redirect_uri) {
    // 통합 검증 함수 사용
    const result = URI.validateAndProcessUri(uri, { corsList: this.corsList })

    if (result.isValid) {
      return result.uri
    }

    // 문제가 있는 경우 로그 기록
    // NOTE: (250528 임시 대응) type=ingame인 경우 redirect_uri가 없기 때문에 empty uri 에러가 무조건 발생합니다.
    // console.warn(`[getRedirectUri] Invalid URI: ${result.message}`)
    // Sentry.withScope((scope) => {
    //   scope.setLevel('warning')
    //   scope.setExtra('uri', uri)
    //   scope.setExtra('message', result.message)
    //   Sentry.captureMessage('[getRedirectUri] Invalid redirect_uri')
    // })

    const defaultUrl = this.localPlatform?.mainUrl || '/'
    return defaultUrl
  }

  gotoRedirect({ clearInsignCookie = true } = {}) {
    const redirectUri = this.getRedirectUri()
    console.warn('gotoRedirect', redirectUri)

    if (clearInsignCookie) {
      this.clearInsignCookie()
    }

    // 메이플M CSP PC 클라 이슈로 핫픽스 대응
    if (redirectUri.replace(/\/$/, '') === 'https://csp.nexon.com/kr/support/register/L127') {
      URI.navigateToUrlWithoutHistory('https://csp.nexon.com/kr/support/register/1276')
      return
    }

    const finalRedirectUri = URI.encodeRedirectUriIfInnerRedirection(redirectUri)

    URI.navigateToUrlWithoutHistory(finalRedirectUri)
  }

  // eslint-disable-next-line class-methods-use-this
  gotoPreCheckRedirect(uri, onAllowURLCB) {
    const checkerFrame = document.createElement('iframe')
    checkerFrame.src = uri
    checkerFrame.style.display = 'none'
    checkerFrame.onload = function () {
      let hasAccessLocation = false
      try {
        hasAccessLocation = !!checkerFrame.contentWindow.location.href
      } catch (e) {
        hasAccessLocation = false
      }
      if (hasAccessLocation) {
        const contentWindow = checkerFrame.contentWindow ? checkerFrame.contentWindow : checkerFrame.contentWindow
        if (onAllowURLCB) {
          onAllowURLCB({ url: contentWindow.location.href })
        }
      }
    }
    document.body.appendChild(checkerFrame)
  }

  loadingTimeout() {
    alert(window.$t('LOADING_SIGNIN_TIMEOUT_ALERT'))
    URI.navigateToUrlWithoutHistory(this.localPlatform?.mainUrl)
  }

  async successToSignin() {
    window.$showLoginLoading()

    const { type, ial } = this.queryParam
    // const timer = setTimeout(() => this.loadingTimeout(), LOADING_TIMEOUT)

    if (ial) { // IAL 페이지에서 로그인 시도 시 _ifinsign 쿠키 유지한 채로 redirect 주소로 이동
      return this.gotoRedirect({ clearInsignCookie: false })
    }

    if (type === 'ingame') {
      return this.redirectForGame('success')
    } if (type === 'ingame-mobile') {
      // clearTimeout(timer)
      return this.redirectForMobile('success')
    }

    return this.gotoRedirect()
  }

  async redirectForGame(t, err) {
    let type = t
    let error = err
    let redirectUri
    const { port: portParam, hsid } = this.queryParam
    const port = portParam || 12121
    const hookSessionId = hsid
    const { webToken } = this.infaceAuth

    if (type === 'success' && !webToken) {
      type = 'fail'
      error = {
        code: 113905,
        message: 'NOT_DEFINED_WEB_TOKEN',
      }
    }

    if (type === 'success') {
      // Success for 게임런칭(KRPC,웹UI)
      const npp = this.infaceAuth?.platform?.npp
      redirectUri = `http://127.0.0.1:${port}/signin/success?web_token=${webToken}&hsid=${hookSessionId}&npp=${npp || ''}`
    } else {
      // Error for 게임런칭(KRPC,웹UI)
      const {
        code,
        message,
      } = error

      redirectUri = `http://127.0.0.1:${port}/signin/${type}?code=${code}&message=${message}&hsid=${hookSessionId}`

      console.error('[INGAME FAIL]', redirectUri)
      Sentry.addBreadcrumb({
        type: 'navigation',
        category: 'type.ingame',
        data: {
          type,
          to: redirectUri,
        },
        level: 'info',
      })
      // if (typeof Sentry?.captureException === 'function') {
      //   const sentryError = new Error(message, { cause: error })
      //   sentryError.name = `[${code}] ${message}`
      //   Sentry.captureException(sentryError, { error, redirectUri })
      // }
    }

    this.clearInsignCookie()
    await LNA.checkLNAPermission() // 로컬 네트워크 접근 권한 체크

    const uaParser = new UAParser()
    console.debug(`UAParser browser[${uaParser.getBrowser().name}]`, uaParser.getResult())
    if (this.isIE() || uaParser.getBrowser().name === 'Safari') {
      URI.navigateToUrlWithoutHistory(redirectUri) // ingame 은 redirectUri 가 nexon.com 도메인이 아니기 때문에 uri 검증 없이 바로 이동
      return
    }

    // INFACE-1797 게임클라이언트에서 로그인 취소후 브라우저에서 로그인 진행시 연결거부 페이지 나타나지 않도록 방식 변경함.
    this.gotoPreCheckRedirect(redirectUri, (info) => {
      if (error && error.code === 113909) { // 비정상접근 에러면 홈으로 이동
        URI.navigateToUrlWithoutHistory(this.localPlatform?.mainUrl)
        return
      }

      const targetUrl = info.url
      if (targetUrl) {
        URI.navigateToUrlWithoutHistory(targetUrl)
      }
    })
  }

  redirectForMobile(type, error) {
    let redirectUri

    const { webToken } = this.infaceAuth
    const id = getParameterByName('id') ?? ''
    const pw = getParameterByName('pw') ?? ''

    if (type === 'success') {
      // eslint-disable-next-line max-len
      redirectUri = `insign://signin/success?web_token=${encodeURIComponent(webToken)}&id=${encodeURIComponent(id)}&pw=${encodeURIComponent(pw)}`
    } else {
      // Error for 게임런칭(PC/모바일)
      const {
        code,
        message,
      } = error

      redirectUri = `insign://signin/fail?code=${code}&message=${message}`

      console.error('[INGAME-MOBILE FAIL]', redirectUri)
      Sentry.addBreadcrumb({
        type: 'navigation',
        category: 'type.ingame-mobile',
        data: {
          type,
          to: redirectUri,
        },
        level: 'info',
      })
      // if (typeof Sentry?.captureException === 'function') {
      //   const sentryError = new Error(message, { cause: error })
      //   sentryError.name = `[${code}] ${message}`
      //   Sentry.captureException(sentryError, { error, redirectUri })
      // }
    }

    this.clearInsignCookie()
    URI.navigateToUrlWithoutHistory(redirectUri)
  }

  gotoLocalSignin() {
    // 로컬 로그인 페이지 이동
    let url = this.localPlatform.signinUrl
    const redirectUri = this.getRedirectUri()

    const innerRedirect = redirectUri ? InfaceEnv.encrypt(redirectUri) : ''
    const redirect = encodeURIComponent(`${LOCATION.origin}/sso/${this.localPlatform.path}?redirect_uri=${innerRedirect}`)
    url += redirect

    URI.navigateToUrlWithoutHistory(url)
  }

  /** @param {URLSearchParams} params */
  async gotoLocalSignout(params) {
    const { origin, pathname, search } = window.location
    let signoutParams

    if (!params || !(params instanceof URLSearchParams)) {
      signoutParams = new URLSearchParams(search)
    } else {
      // 원본 params를 수정하지 않도록 복사본 생성
      signoutParams = new URLSearchParams(params.toString())
    }

    signoutParams.delete('with_signout') // 로그아웃 후 돌아올 때는 해당 쿼리 제거 (무한 로그아웃 방지)
    await this.infaceAuth.gotoSignOut({
      redirect_uri: `${origin}${pathname}?${signoutParams.toString()}`,
    })
  }

  /** @param {URLSearchParams} params */
  async processSignout(params = null) { // null로 변경하여 명확히 구분
    if (this.infaceAuth?.platform?.type === 'arena') {
      // ARENA 플랫폼은 AToken 만료를 위해 로컬 로그아웃 페이지 진입
      await this.gotoLocalSignout(params)
    } else {
      // KRPC, JPPC 는 로컬 세션 NPP 에 직접 접근이 가능하여 바로 만료
      const expireResult = await this.infaceAuth.expireWebToken()
      this.webAuthService.addBreadcrumbByInfaceAuthMethod('expireWebToken', expireResult)
    }
  }

  async gotoSignin() {
    try {
      // 웹토큰 발급 전 크로스도메인 확인
      this.infaceAuth.client.referrerDomain = this.queryParam.referrer

      // 토큰 검증
      if (!this.infaceAuth.client.useCorsReferrer) {
        const verifyResult = await this.infaceAuth.verifyWebToken()
        this.webAuthService.addBreadcrumbByInfaceAuthMethod('verifyWebToken', verifyResult)

        if (verifyResult.code === 200) { // 로그인 완료
          await this.successToSignin()
          return
        } if (verifyResult.code === 113102) { // 지역세션이 만료되었을 경우
          this.gotoLocalSignin()
          return
        } if (verifyResult.code === 113103) { // 토큰 검증 실패
          throw new InfaceAuthError({ code: verifyResult.code, response: verifyResult.response, data: verifyResult.errorData })
        }
      }

      // 역방향
      const reverseResult = await this.infaceAuth.reverseFlow()
      this.webAuthService.addBreadcrumbByInfaceAuthMethod('reverseFlow', reverseResult)

      if (reverseResult.code === 200) { // 로그인 완료
        const uri = this.getRedirectForTicket(reverseResult.data)
        if (uri) {
          URI.navigateToUrlWithoutHistory(uri)
          return
        }

        await this.successToSignin()
        return
      } if (reverseResult.code === 113104) { // 토큰 발급 실패
        throw new InfaceAuthError({ code: reverseResult.code, response: reverseResult.response, data: reverseResult.errorData })
      }

      this.gotoLocalSignin()
    } catch (e) {
      console.error(e)
      const err = e instanceof InfaceAuthError ? e : new InfaceAuthError({
        code: 113903, name: 'FAIL_TO_GOTO_SIGNIN', message: window.$t('FAIL_TO_GOTO_SIGNIN'), data: e,
      })
      throw err
    }
  }

  async processSignin() {
    try {
      const { type } = this.queryParam
      const withSignout = getParameterByName('with_signout') === 'true'

      if (withSignout && this.infaceAuth.webToken) {
        const action = await window.$globalModal.confirm({ // 로그아웃 안내 모달
          message: this.$t('with_signout_confirm_message', { ns: 'common' }),
        })

        // 취소 시 로그아웃 진행 후 로그인 페이지 이동 (확인 시 현재 로그인 된 계정 유지)
        if (action === window.$globalModal.ACTION.CANCEL) {
          await this.processSignout()
        }
      }

      if (type === 'nxplug') {
        const nxPlug = new NxPlug({ phase: 'signin', insignOrigin: ENV_VALUE.INSIGN_GW_URL, ...this.queryParam })
        nxPlug.gotoSignIn()
        return
      }
      this.saveReferrer() // referrer 저장
      await this.gotoSignin()
    } catch (e) {
      console.error('[GW]::processSignin::', e)
      throw e
    }
  }

  gotoPlatformSignin() {
    const { authSelector } = this.infaceAuth.gidSetting

    try {
      const platformSigninInstance = new PlatformSignin({ mainUrl: ENV_VALUE.INSIGN_GW_URL, authSelector })
      const externalOnly = getParameterByName('external_only') === 'true'
      platformSigninInstance.processAuthSelector({ externalOnly })
    } catch (e) {
      console.error('[gotoPlatformSignin]', e)
    }
  }

  getRedirectForTicket(data) {
    const { referrer } = this.queryParam
    const ticket = data?.web_ticket

    let uri

    if (referrer && ticket) {
      const redirectUri = this.getRedirectUri()
      this.clearInsignCookie()
      uri = `${referrer}/${PATH.SSO_TICKET}?ticket=${encodeURIComponent(ticket)}&redirect_uri=${encodeURIComponent(redirectUri)}`
    }

    return uri
  }

  async redirectOfSignin() {
    try {
      window.$showLoginLoading()

      Sentry.addBreadcrumb({
        type: 'debug',
        category: 'platform',
        data: this.infaceAuth.platform,
        level: 'debug',
      })

      const { type } = this.queryParam
      if (type === 'nxplug') {
        const nxPlug = new NxPlug({ phase: 'sso/jppc', insignOrigin: ENV_VALUE.INSIGN_GW_URL, ...this.queryParam })
        nxPlug.processSignIn()
        return
      }

      // 웹토큰 발급 전 크로스도메인 확인
      this.infaceAuth.client.referrerDomain = this.queryParam.referrer

      // 역방향
      const reverseResult = await this.infaceAuth.reverseFlow()
      this.webAuthService.addBreadcrumbByInfaceAuthMethod('reverseFlow', reverseResult)

      if (reverseResult.code === 200) { // 로그인 완료
        const uri = this.getRedirectForTicket(reverseResult.data)
        if (uri) {
          URI.navigateToUrlWithoutHistory(uri)
          return
        }

        await this.successToSignin()
        return
      }

      throw new InfaceAuthError({ code: reverseResult.code, response: reverseResult.response, data: reverseResult.errorData }) // 토큰 발급 실패
    } catch (e) {
      const err = e instanceof InfaceAuthError ? e : new InfaceAuthError({
        code: 113904, name: 'FAIL_TO_REDIRECT_OF_SIGNIN', message: window.$t('FAIL_TO_REDIRECT_OF_SIGNIN'), data: e,
      })
      throw err
    }
  }

  async redirectOfSimpleSignup() {
    const url = this.localPlatform.ssoSigninUrl
    const { type } = this.queryParam

    if (type === 'ingame-mobile' || type === 'ingame' || !url) {
      await this.successToSignin()
    } else { // web 만 로컬세션 생성
      const redirect = encodeURIComponent(`${window.location.origin}${GW_PATH.SSO_SIMPLE}`)
      URI.navigateToUrlWithoutHistory(url + redirect)
    }
  }

  async ssoTokenRoaming({ byTicket = false }) {
    try {
      const redirectUri = getParameterByName('redirect_uri')
      const gid = getParameterByName('gid')

      // 통합 검증 함수 사용
      const result = URI.validateAndProcessUri(redirectUri, { decrypt: false, corsList: this.corsList })

      if (!result.isValid) {
        // 최종 목적지가 허용 도메인이 아니라면 비로그인 상태로 이동
        if (result.name === 'NOT_IN_ALLOWLIST') {
          URI.navigateToUrlWithoutHistory(result.uri)
          return
        }

        // 문제가 있는 경우 로그 기록
        console.warn(`[ssoTokenRoaming] Invalid URI: ${result.message}`)
        Sentry.withScope((scope) => {
          scope.setLevel('warning')
          scope.setExtra('uri', result.uri)
          scope.setExtra('message', result.message)
          Sentry.captureMessage('[ssoTokenRoaming] Invalid redirect_uri')
        })

        throw new InfaceAuthError({ code: 113999, name: 'INVALID_REDIRECT_URI', message: '[ssoTokenRoaming] Invalid redirect_uri' })
      }

      const sso = new SSO({
        mainUrl: ENV_VALUE.INSIGN_GW_URL,
        infaceAuth: this.infaceAuth,
        redirectUri,
        decodedRedirectUri: result.uri,
      })

      if (byTicket) {
        const webTicket = getParameterByName('ticket')
        if (!webTicket) {
          console.error('[ssoTokenRoaming] Missing ticket parameter')
          Sentry.withScope((scope) => {
            scope.setLevel('warning')
            Sentry.captureMessage('[ssoTokenRoaming] Missing ticket parameter')
          })
          return
        }

        await sso.processTokenRoamingByTicket({ gid, webTicket })
        return
      }

      const gameToken = getParameterByName('game_token')
      if (!gameToken) {
        console.error('[ssoTokenRoaming] Missing game_token parameter')
        Sentry.withScope((scope) => {
          scope.setLevel('warning')
          Sentry.captureMessage('[ssoTokenRoaming] Missing game_token parameter')
        })
        throw new InfaceAuthError({ code: 113907, name: 'NOT_DEFINED_SSO_TOKEN', message: window.$t('NOT_DEFINED_SSO_TOKEN') })
      }

      await sso.processTokenRoaming({ gid, gameToken })
    } catch (e) {
      console.error('[ssoTokenRoaming]', e)
      throw e
    }
  }

  async ssoTokenRoamingForWebGame() {
    const redirectUri = getParameterByName('redirect_uri')

    // 통합 검증 함수 사용
    const result = URI.validateAndProcessUri(redirectUri, { decrypt: false, corsList: this.corsList })

    if (!result.isValid) {
      // 최종 목적지가 허용 도메인이 아니라면 비로그인 상태로 이동
      if (result.namae === 'NOT_IN_ALLOWLIST') {
        URI.navigateToUrlWithoutHistory(result.uri)
        return
      }

      // 문제가 있는 경우 로그 기록
      console.warn(`[ssoTokenRoamingForWebGame] Invalid URI: ${result.message}`)
      Sentry.withScope((scope) => {
        scope.setLevel('warning')
        scope.setExtra('uri', result.uri)
        scope.setExtra('message', result.message)
        Sentry.captureMessage('[ssoTokenRoamingForWebGame] Invalid redirect_uri')
      })

      throw new InfaceAuthError({ code: 113999, name: 'INVALID_REDIRECT_URI', message: '[ssoTokenRoamingForWebGame] Invalid redirect_uri' })
    }

    try {
      const ssoForWebGame = new SSOForWebGame({
        env: ENV,
        mainUrl: ENV_VALUE.INSIGN_GW_URL,
        infaceAuth: this.infaceAuth,
        decodedRedirectUri: result.uri,
        securityUrl: ENV_VALUE.ACCOUNT_SECURITY_URL,
      })
      await ssoForWebGame.processTokenRoaming()
    } catch (e) {
      console.error('[ssoTokenRoamingForWebGame]', e)
      throw e
    }
  }

  async gotoIalConsoleLinkingPage() {
    try {
      const consoleLinking = new ConsoleLinking({ infaceAuth: this.infaceAuth, queryParams: this.queryParam })
      await consoleLinking.gotoIalPage()
    } catch (e) {
      console.error('[gotoIalConsoleLinkingPage]', e)
      throw e
    }
  }

  gotoIalTwitchLinkingPage() {
    try {
      const twitchLinking = new TwitchLinking({ mainUrl: ENV_VALUE.INSIGN_GW_URL })
      twitchLinking.processTwitchLinking()
    } catch (e) {
      console.error('[gotoIalTwitchLinkingPage]', e)
    }
  }

  gotoIalChzzkLinkingPage() {
    try {
      const chzzkLinking = new ChzzkLinking({ mainUrl: ENV_VALUE.INSIGN_GW_URL })
      chzzkLinking.processLinking()
    } catch (e) {
      console.error('[gotoIalChzzkLinkingPage]', e)
    }
  }

  gotoIalDiscotechLinkingPage() {
    try {
      const discotechLinking = new DiscotechLinking({ mainUrl: ENV_VALUE.INSIGN_GW_URL })
      discotechLinking.processLinking()
    } catch (e) {
      console.error('[gotoIalDiscotechLinkingPage]', e)
      throw e
    }
  }

  async gotoSignout() {
    // 로컬 로그아웃 페이지에서 웹토큰을 지우므로 이동 전에 만료 호출 (NPP 등 로컬세션 남긴채로 로컬 로그아웃 이동, g_AToken 은 제거)
    const expireResult = await this.infaceAuth.expireWebToken({ doClearSession: this.localPlatform.arena })
    this.webAuthService.addBreadcrumbByInfaceAuthMethod('expireWebToken', expireResult)

    // if (this.infaceAuth.isInvalidLocalSession()) { // 비로그인 시
    //   this.gotoRedirect()
    //   return
    // }

    // 로컬 로그아웃 페이지 이동
    let url = this.localPlatform.signoutUrl
    const redirectUri = this.getRedirectUri()

    if (redirectUri) {
      const innerRedirect = InfaceEnv.encrypt(redirectUri)
      const redirect = encodeURIComponent(`${window.location.origin}/signed-out?redirect_uri=${innerRedirect}`)
      url += redirect
    }

    URI.navigateToUrlWithoutHistory(url)
  }

  /**
   * 회원가입 페이지 이동
   */
  gotoSignup() {
    let url = this.localPlatform.signupUrl // 로컬 가입 페이지
    const redirectUri = this.getRedirectUri()

    if (this.localPlatform.useSimpleSignup) {
      url = `${ENV_VALUE.INSIGN_GW_URL}/${PATH.SIMPLE_SIGNUP}/?redirect_uri=` // 간편 가입 페이지
    }

    const innerRedirect = redirectUri ? InfaceEnv.encrypt(redirectUri) : ''
    const redirect = encodeURIComponent(`${window.location.origin}/signed-up?redirect_uri=${innerRedirect}`)
    url += redirect

    URI.navigateToUrlWithoutHistory(url)
  }

  gotoAccount() {
    // 로컬 계정관리 페이지 이동
    const url = this.localPlatform.accountUrl
    URI.navigateToUrlWithoutHistory(url)
  }

  async authorizeOAuth() {
    try {
      const oauthInstance = new IacOAuth({ mainUrl: ENV_VALUE.INSIGN_GW_URL, corsList: this.corsList })
      if (oauthInstance.hasError()) return

      const { origin, pathname, search } = window.location
      const params = new URLSearchParams(search)
      const clientId = getParameterByName('client_id')

      if (clientId) {
        // geto 등 제한된 클라이언트에서 OAUTH 연동시, 게임 실행을 차단하는 경우.
        if ([...DISABLED_WEB_LAUNCH_CLIENT_IDS].includes(clientId)) {
          cookie?.set(COOKIE.DISABLE_WEB_LAUNCH, 'geto-client', { domain: '.nexon.com' })
        }
      }

      // prompt=login 파라미터가 있는 경우 로그아웃 처리
      const prompt = getParameterByName('prompt')
      if (prompt === 'login') {
        params.delete('prompt') // 로그아웃 후 돌아올 때는 해당 쿼리 제거 (무한 로그아웃 방지)
        await this.processSignout(params)
      }

      await this.infaceAuth.init()
      const clientVerifyResult = await oauthInstance.checkVerifyClient(this.infaceAuth.platform.type)

      // 비로그인 시 로그인 처리(로컬페이지 이동)
      if (!this.infaceAuth.isSignedIn()) {
        // Oauth 클라이언트 검증이 실패하는 경우 더이상 진행하지않고 리다이렉트 시킴
        if (clientVerifyResult?.status === STATUS.OK) {
          // 내부 함수 호출이 아닌 url 직접 이동 (cors 플로우가 아닌 일반 로그인 플로우를 타기 위함))
          await this.infaceAuth.gotoSignIn({
            redirect_uri: `${origin}${pathname}?${params.toString()}`,
            ...(this.infaceAuth.platform.type.toUpperCase() === 'KRPC' && clientVerifyResult?.accessCode) && {
              options: {
                krpc: {
                  memberAccessCode: `${clientVerifyResult?.accessCode}`,
                },
              },
            },
          })
        }
        return
      }

      await oauthInstance.processAuthorization()
    } catch (e) {
      console.error('[authorizeOAuth]', e)
    }
  }

  async gotoLogin() {
    try {
      const withSignout = getParameterByName('with_signout') === 'true'
      if (withSignout && this.infaceAuth.webToken) { // 로그아웃 처리 (웹토큰 만료 및 로컬 쿠키 제거)
        await this.processSignout()
      }

      const termsInstance = new IacTerms({
        mainUrl: ENV_VALUE.INSIGN_GW_URL,
        securityUrl: ENV_VALUE.ACCOUNT_SECURITY_URL,
        gameAuthService: this.gameAuthService,
        infaceAuth: this.infaceAuth,
        useGameToken: this.useGameToken,
      })

      await termsInstance.processLogin()
    } catch (e) {
      console.error('[gotoLogin]', e)
    }
  }

  async processLogout() {
    const isLogin = await this.gameAuthService.insignGameAuth.isLogin
    if (isLogin) {
      const expireResult = await this.infaceAuth.expireWebToken()
      this.webAuthService.addBreadcrumbByInfaceAuthMethod('expireWebToken', expireResult)
      await this.gameAuthService.processLogout()
    }
    this.gotoRedirect()
  }

  gotoLoginSelector(path) {
    try {
      const loginSelector = new LoginSelector({ mainUrl: ENV_VALUE.INSIGN_GW_URL })

      if (path === GW_PATH.LOGIN_SELECTOR) {
        loginSelector.processLoginSelector({ headless: false })
      } else {
        loginSelector.processLoginSelector({ headless: true })
      }
    } catch (e) {
      console.error('[gotoLoginSelector]', e)
    }
  }

  async gotoToyTermsPage() {
    try {
      const withSignout = getParameterByName('with_signout') === 'true'
      if (withSignout && this.infaceAuth.webToken) { // 로그아웃 처리 (웹토큰 만료 및 로컬 쿠키 제거)
        await this.processSignout()
      }

      const termsInstance = new IacTerms({
        mainUrl: ENV_VALUE.INSIGN_GW_URL,
        gameAuthService: this.gameAuthService,
        infaceAuth: this.infaceAuth,
        useGameToken: this.useGameToken,
      })

      await termsInstance.processConsentTerms()
    } catch (e) {
      console.error('[gotoToyTermsPage]', e)
    }
  }

  gotoAccountSettingPage() {
    try {
      const saInstance = new AccountSetting({ mainUrl: ENV_VALUE.INSIGN_GW_URL })
      saInstance.processAccountSetting()
    } catch (e) {
      console.error('[gotoAccountSettingPage]', e)
    }
  }

  async gotoPlayNowPage(path) {
    try {
      const playNowInstance = new PlayNow({
        mainUrl: ENV_VALUE.INSIGN_GW_URL,
        gameAuthService: this.gameAuthService,
        infaceAuth: this.infaceAuth,
        path,
      })

      if (path === GW_PATH.PLAYNOW_SIGNIN) {
        await playNowInstance.processPlayNowSignIn()
      } else if (path === GW_PATH.PLAYNOW_SIGNOUT) {
        await playNowInstance.processPlayNowSignOut()
      } else {
        await playNowInstance.processPlayNow()
      }
    } catch (e) {
      console.error('[gotoPlayNowPage]', e)
    }
  }

  gotoIivPage() {
    try {
      const iivInstance = new IIV({ mainUrl: ENV_VALUE.INSIGN_GW_URL })
      console.debug('[gotoIivPage] iivInstance', iivInstance)
      iivInstance.processIIV()
    } catch (e) {
      console.error('[gotoIivPage]', e)
    }
  }
}

// async function installPlugin() {
// await import('./plugins/i18next.js')
// await import('../i18next/index.js')
// if (LOCALE_PARAM) {
//   console.debug('$i18next.changeLanguage()', LOCALE_PARAM)
//   window.$i18next.changeLanguage(LOCALE_PARAM)
// }

// await Promise.all([
//   import('./plugins/showLoading.js'),
//   import('./plugins/globalModal.js'),
// ])
// }

async function main() {
  const insign = new INSIGN()
  insign.init()
}

window.addEventListener('onInstallPlugin', main)

showInsignLog(packageJson)
